import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function exportPeriodPdf(
  element: HTMLElement,
  projectName: string,
  fromDate: string,
  toDate: string
) {
    const exportBtn = document.getElementById("period-export-btn");

if (exportBtn) {
  exportBtn.style.display = "none";
}
  const canvas = await html2canvas(element, {
    scale: 3,
    useCORS: true,
    allowTaint: true,
    backgroundColor: "#ffffff",
    scrollY: -window.scrollY,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
  });

  if (exportBtn) {
  exportBtn.style.display = "";
}

  const pdf = new jsPDF("p", "mm", "a4");

  const pageWidth = 210;
  const pageHeight = 297;

  const margin = 10;

  const printableWidth = pageWidth - margin * 2;
  //const printableHeight = pageHeight - margin * 2;
    const printableHeight = pageHeight - margin * 2 - 8;

  // Scale factor from canvas pixels to PDF mm
  const scale = printableWidth / canvas.width;

  // Height (in canvas pixels) that fits on one PDF page
  const pageCanvasHeight = Math.floor(printableHeight / scale);

  let renderedHeight = 0;
  let pageNumber = 0;

  while (renderedHeight < canvas.height) {
    const pageCanvas = document.createElement("canvas");

    pageCanvas.width = canvas.width;
    pageCanvas.height = Math.min(
      pageCanvasHeight,
      canvas.height - renderedHeight
    );

    const ctx = pageCanvas.getContext("2d");

    if (!ctx) break;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

    ctx.drawImage(
      canvas,
      0,
      renderedHeight,
      canvas.width,
      pageCanvas.height,
      0,
      0,
      canvas.width,
      pageCanvas.height
    );

    const imgData = pageCanvas.toDataURL("image/png");

    if (pageNumber > 0) {
      pdf.addPage();
    }

    const imgHeight =
      (pageCanvas.height * printableWidth) / pageCanvas.width;

    pdf.addImage(
      imgData,
      "PNG",
      margin,
      margin,
      printableWidth,
      imgHeight,
      undefined,
      "FAST"
    );

    renderedHeight += pageCanvas.height;
    pageNumber++;
  }

  const safeProject = projectName
    .replace(/[\\/:*?"<>|]/g, "")
    .replace(/\s+/g, "_");

  const safeFrom = fromDate.replace(/\//g, "-");
  const safeTo = toDate.replace(/\//g, "-");

  pdf.save(
    `${safeProject}_Period_${safeFrom}_to_${safeTo}.pdf`
  );
}